import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeFaveCustom } from '../CollectionPanel/redux/actionCreators';
import { getFaveCount, getIsFaveLoading, getIsFavourite, } from '../CollectionPanel/redux/selectors';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
export function useFaveButton(deviation, notificationQueue) {
    var _a, _b;
    if (notificationQueue === void 0) { notificationQueue = 'default'; }
    var isFavourite = useSelector(function (state) { return getIsFavourite(state, deviation); });
    var isLoading = useSelector(function (state) { return getIsFaveLoading(state, deviation); });
    var faveCount = useSelector(function (state) { return getFaveCount(state, deviation); });
    var dispatch = useDispatch();
    var biData = BiData({
        evid: isFavourite ? 109 : 102,
        typeid: getDeviationResourceType(deviation),
        creatorid: (_b = (_a = deviation.author) === null || _a === void 0 ? void 0 : _a.useridUuid) !== null && _b !== void 0 ? _b : '',
        itemid: deviation.deviationId,
        sectionname: BiContextProvidedValue,
        sectionid: BiContextProvidedValue,
        section_typeid: BiContextProvidedValue,
        sectiontype: BiContextProvidedValue,
        sectionrank: BiContextProvidedValue,
        rank: BiContextProvidedValue,
        sort_type: BiContextProvidedValue,
        reason_shown: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
    });
    var onClick = useCallback(function () {
        return dispatch(changeFaveCustom(deviation, !isFavourite, notificationQueue));
    }, [deviation, dispatch, isFavourite, notificationQueue]);
    return { isFavourite: isFavourite, faveCount: faveCount, isLoading: isLoading, biData: biData, onClick: onClick };
}
//# sourceMappingURL=useFaveButton.js.map